/*
This file should only contains actions that take place when the DOM document
is initially loaded (initial page load).
 */

var docObj = $(document);

/***************************************
 * CSS Class Events
 ***************************************/
docObj.ready(function() {

    mwl.attachFormControlUnderlining();

    mwl.attachSlidePanelEvents();

    $(document).ready(function() {
        $('.floating-sidebar').each(function() {
            var sidebar = $(this);
            var container = sidebar.parent('div');
            container.removeClass('hidden-xs').removeClass('hidden-sm');
            container.css('width',sidebar.outerWidth(true) + 'px');
            sidebar.css('position','fixed');
            container.addClass('hidden-xs').addClass('hidden-sm');
        });
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/DOMInitialization.js